import { DynamicPropertyGroupDtoToEntity } from "src/app/features/DynamicPropertyGroup/services/mappers/DynamicPropertyGroupDtoToEntity";
import type { DynamicPropertyGroupDto } from "src/app/features/DynamicPropertyGroup/types/DynamicPropertyGroupDto";
import type { DynamicPropertyGroupEntity } from "src/app/features/DynamicPropertyGroup/types/DynamicPropertyGroupEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const DynamicPropertyGroupTableDtoMapper = (
    input: Readonly<ResourcePageDto<DynamicPropertyGroupDto>>,
): ResourcePageEntity<DynamicPropertyGroupEntity> => {
    return {
        list: input.list ? input.list.map(DynamicPropertyGroupDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
